<template>
  <div class="breadcrumb" v-if="visible && breadcrumbList && breadcrumbList.length > 0">
    <ul>
      <li @click="routeTo(home)" class="linked">
        <q-img
          :src="require(`./assets/home.svg`)"
          alt="home"
          class="icon"
        />
        {{home.name}}
      </li>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(breadcrumb)"
        :class="{'linked': !!breadcrumb.link}"
      >
        <!-- Flecha -->
        <q-img
          :src="require(`./assets/arrow-right.svg`)"
          alt="flecha derecha"
          class="icon"
        />
        {{ breadcrumb.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { QImg } from 'quasar';

export default {
  name: 'Breadcrumbs',
  components: {
    QImg
  },
  data () {
    return {
      breadcrumbList: [],
      home: {
        name: 'Inicio',
        link: '/'
      }
    };
  },
  mounted () {
    this.updateList();
  },
  props: {
    visible: {
      type: Boolean,
      default: () => true
    }
  },
  watch: {
    '$route' () {
      this.updateList();
    }
  },
  methods: {
    routeTo (breadcrumb) {
      if (breadcrumb.link) {
        this.$router.push(breadcrumb.link);
      }
    },
    updateList () {
      if (this.$route.params.nameLink !== undefined) {
        this.breadcrumbList = this.$route.meta(this.$route).breadcrumb;
      } else {
        this.breadcrumbList = this.$route.meta.breadcrumb;
      }
    }
  }
};
</script>

<style scoped>
ul {
  display: flex;
  list-style-type: none;
  padding: 0;
}
li {
  margin: 1px 0 5px 0px;
  font-family: DINPro;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  color: #777;
  text-transform: uppercase;
}
li:hover{
  color:#002f6c;
  font-weight:bold;
}
li:last-child:hover{
  color:#777777;
}
li:last-child{
  font-weight:bold;
}
.linked {
  cursor: pointer;
}
.icon {
  width: 24px;
  height: 24px;
}
.breadcrumb {
  margin-bottom: 20px;
}
.no-visible {
  visibility: 'hidden';
}
</style>
